import React, { useEffect, useState } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import NormalAlert from "../../../Alerts/NormalAlert";
import {
  BookmarkCheck,
  ArrowRight,
  UserPlus,
  Database
} from "lucide-react";

const AdminDashboard = () => {

  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(null);


  const steps = [
    {
      title: "Add Consultant",
      icon: <UserPlus size={40} />,
      link: "/HRSetu/Admin/Add-Consultant",
    },

    {
      title: "Add Employee",
      icon: <UserPlus size={40} />,
      link: "/HRSetu/Admin/Add-Employee",
    },

    {
      title: "Master Data",
      icon: <Database size={40} />,
      link: "/HRSetu/Admin/Master-Data",
    },
  ];

  useEffect(() => {
  const timer = setTimeout(() => {
    setLoading(false);
  }, 800);

  return () => clearTimeout(timer);
}, []);

  return (
    <>
      <div className="w-full min-h-screen bg-[#f3f7fb] flex justify-center pt-32 px-6">
        <div className="max-w-[1400px] w-full">
          {loading ? (
            <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
              <div className="grid grid-cols-4 gap-x-20 gap-y-16">
                {[...Array(8)].map((_, i) => (
                  <div key={i} className="w-[220px] mx-auto">
                    <Skeleton height={120} borderRadius={12} />
                    <Skeleton height={100} className="mt-2" borderRadius={12} />
                  </div>
                ))}
              </div>
            </SkeletonTheme>
          ) : (
            <div className="grid grid-cols-5 gap-x-8 gap-y-12 justify-items-center">
              {steps.map((step, i) => (
                <a
                  key={i}
                  href={step.link}
                  className="group w-[220px] bg-white rounded-b-xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                  style={{ cursor: step.link ? "pointer" : "default" }}
                >
                  {/* Header */}

                  <div className="bg-gradient-to-br from-[#0d47a1] to-[#42a5f5] text-white h-[110px] px-4 rounded-b-xl flex justify-between items-center">
                    {/* Left (Title + Count) */}
                    <div className="flex flex-col">
                      <div className="text-[16px] font-medium">
                        {step.title}
                      </div>
                    </div>

                    {/* Right Icon */}
                    <div className="bg-white rounded-full w-12 h-12 flex items-center justify-center text-blue-700">
                      {React.cloneElement(step.icon, { size: 22 })}
                    </div>
                  </div>

                  {/* Bottom Arrow Section */}

                  <div className="flex justify-end px-4 py-3 bg-white rounded-b-xl">
                    <ArrowRight className="text-blue-600" size={20} />
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>

      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default AdminDashboard;
